import React, { useEffect, useRef, useState } from "react";
import {
  Flex,
  Input,
  Modal,
  DatePicker,
  Button,
  Skeleton,
} from "antd";
import { useNavigate } from "react-router-dom";
import {
  SearchOutlined,
  EnvironmentOutlined,
} from "@ant-design/icons";
import API from "./AppUtils";
import env from "./env.json";
import Navbar from "./components/Navbar";
import GooglePlacesAutocomplete, {
  geocodeByAddress,
  getLatLng,
} from "react-google-places-autocomplete";
import TopFilterBarPotrait from "./components/TopFilterBarPotrait.js";
import useOrientation from "./components/useOrientation";
import DownloadWegetherModal from "./components/DownloadWegetherModal";
//import InfiniteScroll from "react-infinite-scroll-component";
import CardList from "./components/CardList.js";
import PartyIcon from "./components/PartyIcon.js";
import { sortByDistance } from "./common/helper.js";
//import { getFilteredTours } from "./common/helper.js";
import axios from "axios";
import { IoMdGlobe } from "react-icons/io";
import { IoCompassOutline } from "react-icons/io5";
import dayjs from "dayjs";
import advancedFormat from "dayjs/plugin/advancedFormat";
import customParseFormat from "dayjs/plugin/customParseFormat";
import localeData from "dayjs/plugin/localeData";
import weekday from "dayjs/plugin/weekday";
import weekOfYear from "dayjs/plugin/weekOfYear";
import weekYear from "dayjs/plugin/weekYear";
import {
  addUsersTourDataToUrl,
  getUsersTourDataFromUrl,
} from "./common/helper.js";
import TopFilterBarLandscape from "./components/TopFilterBarLandscape.js";
import ParticipantsControlModal from "./components/ParticipantsControlModal.js";

dayjs.extend(customParseFormat);
dayjs.extend(advancedFormat);
dayjs.extend(weekday);
dayjs.extend(localeData);
dayjs.extend(weekOfYear);
dayjs.extend(weekYear);

const { RangePicker } = DatePicker;
const GOOGLE_API_KEY = env.GOOGLE_API_KEY;
const calculatedDefaultStartDate = dayjs().add(7, "day").format("YYYY-MM-DD");
const calculatedDefaultEndDate = dayjs().add(14, "day").format("YYYY-MM-DD");
const popularDestinations = [
  "San Juan, Puerto Rico",
  "Mexico City, CMDX, Mexico",
  "Oaxaca de Juárez, Oax, Mexico",
  "Rio de Janeiro, RJ, Brazil",
];

const Landing = () => {
  const initialUsersTourData = getUsersTourDataFromUrl(window.location.href);

  const getDestinationLabelSearchParam = () => {
    return new URLSearchParams(window.location.search).get("destinationLabel");
  };

  const [allTours, setAllTours] = useState(null);
  const [destination, setDestination] = useState(
    { label: initialUsersTourData?.searchedLocationLabel || "Boston, MA" }
  );
  const [hasDestinationChanged, setHasDestinationChanged] = useState(false);
  const [startDate, setStartDate] = useState(
    initialUsersTourData?.startDate || calculatedDefaultStartDate
  );
  const [endDate, setEndDate] = useState(
    initialUsersTourData?.endDate || calculatedDefaultEndDate
  );
  const [isShared, setIsShared] = useState(
    initialUsersTourData?.partyType
      ? initialUsersTourData?.partyType === "Shared"
      : true
  );
  const [guests, setGuests] = useState(
    initialUsersTourData?.guests || {
      adults: 1,
      children: 0,
      elderly: 0,
    }
  );
  const [guestModalVisible, setGuestModalVisible] = useState(false);
  const [searchModal, setSearchModal] = useState(false);
  const [downloadAppModalVisible, setDownloadAppModalVisible] = useState(false);
  const isPortrait = useOrientation();
  const [isBlinking, setIsBlinking] = useState(false);

  const [hasGuestChanged, setHasGuestChanged] = useState(false);
  const [resultsFound, setResultsFound] = useState(false);
  const [latLongDestination, setLatLongDestination] = useState(
    initialUsersTourData?.latLongDestination || {
      lat: 42.3600825,
      lng: -71.0588801,
    }
  );
  const [loading, setLoading] = useState(false);

  const filterParams = async () => {
    let latLongForFilters;

    if (hasDestinationChanged) {
      latLongForFilters = await getlanglat();
      setHasDestinationChanged(false);
    } else {
      latLongForFilters = latLongDestination;
    }

    return {
      budgetEnd: 5000,
      budgetStart: 0,
      destination: {
        formatedAdd: destination?.label || "Boston, MA",
        lat: latLongForFilters.lat,
        long: latLongForFilters.lng,
      },
      endDate: endDate,
      experienceType: isShared ? "Shared" : "Private",
      partySize: guests?.adults + guests?.children + guests?.elderly,
      startDate: startDate,
    };
  };

  useEffect(() => {
    (async () => {
      setLoading(true);
      const filterParamsRes = await filterParams();
      const data = await API.getFilteredTours(filterParamsRes);
      if (data?.data && Object.values(data?.data).flat().length > 0) {
        setAllTours(Object.values(data?.data).flat());
        setResultsFound(true);
      } else {
        const destinationLabel = getDestinationLabelSearchParam();
        const isValidDestination = await validDestinationChecker(destinationLabel);
        if (!isValidDestination) {
          const url = new URL(window.location.href);
          url.searchParams.delete("destinationLabel");
          window.history.replaceState({}, "", url);
        }
        if (destinationLabel && isValidDestination) {
          console.log("destinationLabel", destinationLabel);
          setHasDestinationChanged(true);
          setDestination({ label: destinationLabel });
        } else {
          const data = await getallTours();
          const sortedData = sortByDistance(data, true, {
            latitude: filterParamsRes?.destination?.lat,
            longitude: filterParamsRes?.destination?.long,
          });
          setAllTours(sortedData);
          setResultsFound(false);
        }
      }
      setLoading(false);
      setIsBlinking(false);
    })();
  }, [destination]);

  const fetchTours = async () => {
    setLoading(true);

    setIsBlinking(false);
    const filterParamsRes = await filterParams();
    const data = await API.getFilteredTours(filterParamsRes);

    if (data?.data && Object.values(data?.data).flat().length > 0) {
      setAllTours(Object.values(data?.data).flat());
      setResultsFound(true);
    } else {
      const fallbackData = await getallTours();
      const sortedData = sortByDistance(fallbackData, true, {
        latitude: filterParamsRes?.destination?.lat,
        longitude: filterParamsRes?.destination?.long,
      });
      setAllTours(sortedData);
      setResultsFound(false);
    }

    setLoading(false);
  };

  async function waitUntil() {
    return await new Promise((resolve) => {
      const interval = setInterval(() => {
        if (window?.google && window?.google?.maps) {
          resolve("foo");
          clearInterval(interval);
        }
      }, 1000);
    });
  }

  async function validDestinationChecker(address) {
    const geocoder = new google.maps.Geocoder();
    try {
      const result = await new Promise((resolve, reject) => {
        geocoder.geocode({ address }, (results, status) => {
          if (status === "OK" && results[0]) {
            const location = results[0].geometry.location;
            resolve({ lat: location.lat(), lng: location.lng() });
          } else {
            reject(status);
          }
        });
      });
      return true;
    } catch (error) {
      return false;
    }
  }

  const getlanglat = async () => {
    await waitUntil();

    const geo = window?.google
      ? await geocodeByAddress(destination.label)
      : [destination.label];
    const latlng = window?.google?.maps
      ? await getLatLng(geo[0])
      : latLongDestination;
    setLatLongDestination(latlng);
    return latlng;
  };

  const handleModalOk = () => {
    if (hasDestinationChanged) {
      setHasDestinationChanged(false);
    }
    setSearchModal(false);
  };
  const hasMounted = useRef(false);
  useEffect(() => {
    if (hasMounted.current) {
      triggerShrinking();
    } else {
      hasMounted.current = true;
    }
  }, [startDate, endDate]);
  const handleGuestModalOk = () => {
    if (hasGuestChanged) {
      setHasGuestChanged(false);
      triggerShrinking();
    }
    setGuestModalVisible(false);
  };

  const triggerShrinking = () => {
    setIsBlinking(true);
  };

  const onRangeChange = (dates, dateStrings) => {
    if (dates) {
      setStartDate(dateStrings[0]);
      setEndDate(dateStrings[1]);
    } else {
      console.log("Clear");
    }
  };

  const handleSelect = async (value) => {
    setHasDestinationChanged(true);
    setDestination(value);
  };
  const handleTabChange = (key) => {
    setIsShared(key === "shared");
    setHasGuestChanged(true);
  };
  const showGuestModal = () => {
    setGuestModalVisible(true);
  };

  const handleGuestChange = (type, operation) => {
    setGuests((prevState) => ({
      ...prevState,
      [type]: Math.max(
        prevState[type] + (operation === "increment" ? 1 : -1),
        0
      ),
    }));
    setHasGuestChanged(true);
  };
  const navigate = useNavigate();

  const handleClick = (experience) => {


  };

  const getallTours = async () => {
    try {
      const response = await API.getPublishedTours();
      return response.data;
    } catch (err) {
      console.log("error Update Profile Api", err);
    }
  };

  useEffect(() => {
    const getLocation = () => {
      navigator.geolocation.getCurrentPosition(success, error);
    };

    const success = async (pos) => {
      const crd = pos.coords;
      setDestination({ label: await fetchCityName(crd.latitude, crd.longitude) });
      setHasDestinationChanged(true);
    };

    const error = (err) => {
      switch (err.code) {
        case err.PERMISSION_DENIED:
          console.log("User denied the request for Geolocation.");
          break;
        case err.POSITION_UNAVAILABLE:
          console.log("Location information is unavailable.");
          break;
        case err.TIMEOUT:
          console.log("The request to get user location timed out.");
          break;
        default:
          console.log("An unknown error occurred.");
          break;
      }
    };

    const fetchCityName = async (latitude, longitude) => {
      try {
        const response = await axios.get(
          `https://maps.googleapis.com/maps/api/geocode/json?latlng=${latitude},${longitude}&key=${env.GOOGLE_API_KEY}`
        );
        const addressComponents = response.data.results[0].address_components;

        const cityComponent = addressComponents.find((component) => {
          return component.types.includes("locality");
        });

        if (cityComponent) {
          const cityName = cityComponent.long_name;
          return cityName;
        } else {
          console.log("City not found");
        }

        const city = addressComponents.find((component) =>
          component.types.includes("locality")
        )?.long_name;

        console.log(`City: ${city}`);
      } catch (error) {
        console.error("Error fetching the city name:", error);
      }
    };

    if (!initialUsersTourData && !getDestinationLabelSearchParam()) {
      getLocation();
    }
  }, []);

  const locationField = (
    <button
      onClick={() => setSearchModal(true)}
      style={{
        width: "100%",
        height: "3rem",
        display: "flex",
        justifyContent: "flex-start",
        alignItems: "center",
        border: "none",
        fontSize: "0.9rem",
        fontWeight: "500",
        border: isPortrait ? "none" : "1px solid lightgrey",
        padding: 0,
        backgroundColor: "white",
        borderRadius: "0.4rem",
      }}
    >
      <div
        style={{
          height: "0.5rem",
          width: "0.5rem",
          minWidth: "0.5rem",
        }}
      ></div>
      <div
        style={{
          height: "1rem",
          width: "1rem",
          minWidth: "1rem",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <EnvironmentOutlined size={"1rem"} />
      </div>
      <div
        style={{
          height: "0.5rem",
          width: "0.5rem",
          minWidth: "0.5rem",
        }}
      ></div>

      <div style={{ color: "black", fontWeight: "500", fontFamily: "Poppins" }}>
        {destination.label}
      </div>
    </button>
  );

  const dateRangeField = (
    <RangePicker
      defaultValue={[
        dayjs(calculatedDefaultStartDate, "YYYY-MM-DD"),
        dayjs(calculatedDefaultEndDate, "YYYY-MM-DD"),
      ]}
      disabledDate={(current) => current && current.isBefore(dayjs(), "day")}
      size="medium"
      style={{
        width: "100%",
        height: "3rem",
        fontWeight: "500",
      }}
      onChange={onRangeChange}
      value={[dayjs(startDate, "YYYY-MM-DD"), dayjs(endDate, "YYYY-MM-DD")]}
    />
  );

  const partyField = (
    <Button
      size="large"
      style={{
        width: "100%",
        height: "3rem",
        fontWeight: "500",
        flexDirection: "row",
        justifyContent: "center",
        alignItems: "center",
      }}
      onClick={showGuestModal}
    >
      <div>
        {Object.values(guests).reduce((acc, curr) => acc + curr, 0) +
          (isShared ? " Shared" : " Private")}
      </div>
      <PartyIcon partyType={isShared ? "shared" : "private"} />
    </Button>
  );

  const searchBar = (
    <Button
      type="primary"
      icon={<SearchOutlined style={{ margin: "1rem" }} />}
      size="large"
      onClick={fetchTours}
      className={isBlinking ? "blinking-border" : ""}
      style={{
        height: "3rem",
        backgroundColor: "#fa5705",
      }}
    ></Button>
  );

  return (
    <Flex
      justify="center"
      vertical
      style={{
        maxWidth: "98vw",
        margin: "0 auto",
        width: "100%",
      }}
    >
      <Navbar
        breadcrumbsVisible={false}
        headerDownloadButtonOnClick={() => setDownloadAppModalVisible(true)}
      />
      <div
        style={{
          height: "4rem",
        }}
      ></div>
      {isPortrait ? (
        <TopFilterBarPotrait
          locationField={locationField}
          dateRangeField={dateRangeField}
          partyField={partyField}
          searchBar={searchBar}
          startDate={startDate}
          endDate={endDate}
          partyText={`${Object.values(guests).reduce((acc, curr) => acc + curr, 0) + " Shared"}`}
        />
      ) : (
        <TopFilterBarLandscape
          locationField={locationField}
          dateRangeField={dateRangeField}
          partyField={partyField}
          searchBar={searchBar}
        />
      )}
      <div style={{ padding: "1.5rem", paddingBottom: "0rem" }}>
        {resultsFound ? (
          <>
            <span
              style={{
                color: "black",
                fontFamily: "Poppins",
                fontWeight: "500",
                display: "flex",
                alignItems: "center",
                marginBottom: "0px !important",
              }}
            >
              <IoCompassOutline style={{ marginRight: "0.3rem" }} />
              Explore {destination.label}
            </span>
            <span
              style={{
                color: "gray",
                fontFamily: "Poppins",
                fontWeight: "500",
                fontSize: "1rem",
                marginLeft: "0.1rem",
              }}
            >
              Discover our experiences and build an unforgettable trip.
            </span>
          </>
        ) : (
          <>
            <span
              style={{
                color: "black",
                fontFamily: "Poppins",
                fontWeight: "500",
                display: "flex",
                alignItems: "center",
                marginBottom: "0px !important",
              }}
            >
              <IoMdGlobe style={{ marginRight: "0.3rem" }} />
              Available Elsewhere
            </span>
            <span
              style={{
                color: "gray",
                fontFamily: "Poppins",
                fontWeight: "500",
                fontSize: "1rem",
                marginLeft: "0.1rem",
              }}
            >
              Experiences offered at other destinations subject to alternative
              dates and availabilities.
            </span>
          </>
        )}
      </div>

      {/* {content} */}
      {!loading && allTours && allTours.length > 0 ? (
        <CardList
          experiences={allTours}
          handleClick={(experience) => {
            navigate(
              addUsersTourDataToUrl(`/experience/${experience?.id}`, {
                experienceId: experience?.id,
                partyType: isShared ? "Shared" : "Private",
                partySize: guests?.adults + guests?.children + guests?.elderly,
                experienceName: experience?.experienceName,
                selectedTime: null,
                searchedLocationLabel: destination?.label,
                guests: guests,
                startDate: startDate,
                endDate: endDate,
                latLongDestination: latLongDestination,
              })
            );
            window.scrollTo(0, 0);
          }}
          partyType={isShared ? "Shared" : "Private"}
          partySize={guests.adults + guests.children + guests.elderly}
        />
      ) : (
        <Flex
          wrap="wrap"
          justify="space-around"
          style={{ padding: "1.5rem", margin: 0 }}
          className="body-flex"
          gap={"large"}
        >
          {Array.from({ length: 20 }, (_, index) => (
            <Skeleton.Node
              active={true}
              style={{
                width: "19rem",
                height: "24rem",
                borderRadius: "0.4rem",
              }}
              key={index}
            />
          ))}

          {Array.from({ length: 4 }, (_, index) => (
            <div
              style={{
                width: "19rem",
                minWidth: "19rem",
                margin: "0",
                overflow: "hidden",
              }}
              key={index}
            ></div>
          ))}
        </Flex>
      )}

      <DownloadWegetherModal
        downloadAppModalVisible={downloadAppModalVisible}
        setDownloadAppModalVisible={setDownloadAppModalVisible}
      />
      {
        <Modal
          title="Destination"
          open={searchModal}
          onCancel={() => setSearchModal(false)}
          onOk={handleModalOk}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              flexDirection: "column",
            }}
          >
            <GooglePlacesAutocomplete
              apiKey={GOOGLE_API_KEY}
              apiOptions={{ language: "en", region: "us" }}
              selectProps={{
                onChange: handleSelect,
                placeholder: "Search for a destination...",
                styles: {
                  container: (provided) => ({
                    ...provided,
                    width: "100%",
                    border: "1px solid #d9d9d9",
                    borderRadius: "5px",
                    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.15)",
                    height: "3rem",
                    height: "60%",
                  }),
                  input: (provided) => ({
                    ...provided,
                    width: "8rem",
                    padding: "8px",
                    borderRadius: "5px",
                    fontSize: "16px",
                    border: "none",
                    boxShadow: "none",
                  }),
                },
              }}
              renderInput={(props) => <Input {...props} />}
            />
            <div
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                flexDirection: "column",
              }}
            >
              <br />
              <div
                style={{
                  display: "flex",
                  justifyContent: "start",
                  alignItems: "start",
                  flexDirection: "column",
                  color: "grey",
                  width: "100%",
                  fontWeight: "500",
                  fontSize: "1rem",
                  marginBottom: "0.5rem",
                }}
              >
                <div
                  style={{
                    color: "grey",
                    fontWeight: "500",
                    fontSize: "1.3rem",
                  }}
                >
                  Popular Destinations:
                </div>
                {popularDestinations.map((destination, index) => (
                  <div
                    onClick={() => {
                      handleSelect({ label: destination });
                      handleModalOk();
                    }}
                    style={{ cursor: "pointer" }}
                    key={index}
                  >
                    {destination}
                  </div>
                ))}
              </div>
            </div>
          </div>
        </Modal>
      }
      <ParticipantsControlModal
        guestModalVisible={guestModalVisible}
        setGuestModalVisible={setGuestModalVisible}
        handleGuestModalOk={handleGuestModalOk}
        handleGuestChange={handleGuestChange}
        guests={guests}
        isShared={isShared}
        handleTabChange={handleTabChange}
        maxParticipants={10}
      />
      <div
        style={{
          display: "none",
        }}
      >
        <GooglePlacesAutocomplete
          apiKey={GOOGLE_API_KEY}
          apiOptions={{ language: "en", region: "us" }}
          selectProps={{
            onChange: handleSelect,
            placeholder: "Search for a destination...",
          }}
        />
      </div>
    </Flex>
  );
};

export default Landing;
